export type BankIdAppState =
    | BankIdState.Initial
    | BankIdState.ThisDevice
    | BankIdState.ExternalDevice;

export enum BankIdState {
    Initial = 'initial',
    ThisDevice = 'this',
    ExternalDevice = 'external'
}